import { ColorEnum } from '@/constants/color'
import ShiftCloseoutIcon from '@/features/ui/icons/components/ShiftCloseoutIcon'
import { FC } from 'react'
import { SvgProps } from 'react-native-svg'

const CloseoutIcon: FC<SvgProps> = (props) => (
    <ShiftCloseoutIcon fill={ColorEnum.GRAY_900} size={16} {...props} />
)

export default CloseoutIcon
